export enum ClassAdditionalInfo {
    LongOp = 'LongOp',
    Crud = 'Crud',
}
